import { render, staticRenderFns } from "./MitraLogos.vue?vue&type=template&id=361ed0bc&"
import script from "./MitraLogos.vue?vue&type=script&lang=js&"
export * from "./MitraLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports